/**
 * Round 16 H24, eighth round -- what the accountable executive is
 * accountable for.
 *
 * His home was the generic one and nothing on it named his seat. He
 * gives the last signature on the minimum viable bank: each MVB pack
 * and the declaration reach him after the CRO, and nothing in the set
 * is in force until he signs. Shown only to a holder of the seat.
 */
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useMe } from "shared/api/useMe";

export function AccountableExecutiveNote() {
  const { t } = useTranslation();
  const me = useMe();
  if (!(me.data?.realm_roles ?? []).includes("ae")) return null;
  return (
    <section
      data-testid="home-ae-standfirst"
      className="rounded-xl border border-paper-2 bg-white p-4 text-sm text-slate-700 shadow-card"
    >
      <h2 className="font-display text-base font-semibold text-slate-900">
        {t("home.ae.heading")}
      </h2>
      <p className="mt-1">{t("home.ae.body")}</p>
      <Link
        to="/my-work"
        data-testid="home-ae-my-work"
        className="mt-2 inline-block text-brand-brassDark hover:underline"
      >
        {t("home.ae.link")}
      </Link>
    </section>
  );
}
